module.exports = __webpack_public_path__ + "img/icon_dean_home_bg_card_5.1199310b.png";